import * as Sentry from "@sentry/react";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { useAuthStore } from "../stores/auth.store";
import * as authApi from "../api/auth.api";

export function useAuth() {
  const { user, isLoading } = useAuthStore();
  const setUser = useAuthStore((s) => s.setUser);
  const navigate = useNavigate();

  const loginWithGoogle = useCallback(async () => {
    const { url } = await authApi.initiateGoogleOAuth();
    window.location.href = url;
  }, []);

  const loginWithMagicLink = useCallback(async (email: string) => {
    await authApi.requestMagicLink(email);
  }, []);

  const handleLogout = useCallback(async () => {
    await authApi.logout();
    setUser(null);
    Sentry.setUser(null);
    navigate("/");
  }, [setUser, navigate]);

  return {
    user,
    isLoading,
    isAuthenticated: !!user,
    loginWithGoogle,
    loginWithMagicLink,
    logout: handleLogout,
  };
}
